import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import useStore from '../../hooks/useStore'

import { LayerContentWrapper, Resources } from './LayerContent.styles'

function LayerContent({ location, children }) {
  const { state, dispatch } = useStore()
  const { activeProject, lang } = state

  const path = location.pathname.match(/\/map\/(\D*)/)
  const layerName = (path && path[1]) || 'surface'

  // and pass value to LayoutDisplay
  function setActiveProject(id, position) {
    dispatch({
      type: 'updateActiveProject',
      payload: {
        id,
        position
      }
    })
  }

  return (
    <LayerContentWrapper className={`layer ${layerName}`}>
      <Resources className={`resources resources--${layerName}`}>
        {children({
          active: activeProject && activeProject.id,
          setActiveProject: setActiveProject,
          lang
        })}
      </Resources>
    </LayerContentWrapper>
  )
}

LayerContent.propTypes = {
  layerName: PropTypes.string,
  children: PropTypes.func,
  lang: PropTypes.string,
  location: PropTypes.object
}

export default withRouter(LayerContent)
